import React from 'react';
import {reduxForm, Field} from 'redux-form';
import StandardField from 'shared/StandardField.jsx';

const CaptainInformationForm = () => (
  <form
    className="animated fadeIn"
    noValidate
  >
    <div className="panel panel-primary">
      <div className="panel-body">
        <div className="flex justify-content direction-column">
          <h2 className="panel-body-sub-heading">{`Captain Information (Required)`}</h2>
          <div className="row">
            <div className="col-sm-4">
              <Field
                name="firstName"
                type="text"
                component={StandardField}
                placeholder="First Name"
              />
            </div>
            <div className="col-sm-4">
              <Field
                name="lastName"
                type="text"
                component={StandardField}
                placeholder="Last Name"
              />
            </div>
            <div className="col-sm-4">
              <Field
                name="email"
                type="text"
                component={StandardField}
                placeholder="Email"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
);

CaptainInformationForm.propTypes = {};

export default reduxForm({
  form: 'captainInformationForm'
})(CaptainInformationForm);



// WEBPACK FOOTER //
// ./src/features/admin/review/CaptainInformationForm.jsx